function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "#009471",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M4.592 6.874c-.146-.234-.297-.487-.063-.633.235-.145.831-.173.977.061.988 1.588 1.306 2.787 1.542 3.428.329.894.51 1.484.637 2.078.072.34.164 1.173.224 1.637.031.245.009-.13.088.54a.5.5 0 01-.994.116 74.735 74.735 0 00-.122-1.014 13.08 13.08 0 00-.174-1.07c-.116-.542-.284-1.089-.597-1.942-.205-.556-.565-1.67-1.518-3.2z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.532 14.605c3.143-.107 3.421-2.893 3.243-5.592-.093-1.415.657-1.992 1.678-3.057.214-.224.08-.659-.2-.746-.828-.259-1.622-.197-2.672-.124-2.533.175-5.828 1.755-6.072 5.052-.04.539.083 1.194.223 1.852.24 1.128.65 2.172 1.26 1.994 0-3.644 3.244-5.608 3.563-5.325.155.138-1.011 1.616-1.412 2.455-.66 1.381-.636 2.784-.636 3.384.393.109.642.12 1.025.107zM3.95 8.847c-2.13.423-2.49-1.444-2.49-2.68 0-.875-.073-1.175-.794-1.716-.152-.113-.1-.359.039-.475.198-.165.47-.269 1.044-.323 1.525-.145 3.714.397 4.213 2.378.221.878-.17 1.762-.596 2.227-.84-1.678-1.958-2.974-2.212-2.712-.087.09.439.759.743 1.431.303.673.512 1.22.628 1.66-.222.107-.313.158-.577.21z"
}));

function SvgPlant(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgPlant;